export interface WhatsAppStatusResponse {
  configured: boolean;
  phoneNumberId: string | null;
  hasToken: boolean;
  provider: string;
}

export interface WhatsAppSendResponse {
  success: boolean;
  configured: boolean;
  simulated?: boolean;
  messageId?: string;
  recipient?: string;
  previewText?: string;
  message?: string;
  notice?: string;
  error?: string;
  metaErrorType?: string;
}

/**
 * Check if WhatsApp Cloud API credentials are configured in server .env
 */
export async function checkWhatsAppStatus(): Promise<WhatsAppStatusResponse> {
  try {
    const res = await fetch('/api/whatsapp/status');
    if (res.ok) {
      return await res.json();
    }
  } catch (err) {
    console.warn('Erro ao verificar status do WhatsApp:', err);
  }
  return {
    configured: false,
    phoneNumberId: null,
    hasToken: false,
    provider: 'Meta for Developers (WhatsApp Cloud API)',
  };
}

/**
 * Trigger unidirectional WhatsApp Notification via Meta Cloud API backend endpoint
 */
export async function sendWhatsAppNotification(
  phone: string,
  title: string,
  message: string,
  suiteNumber?: string
): Promise<WhatsAppSendResponse> {
  try {
    if (!phone || !phone.trim()) {
      return {
        success: false,
        configured: false,
        error: 'Telefone do destinatário não cadastrado.',
      };
    }

    const res = await fetch('/api/whatsapp/send-notification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phone: phone.trim(),
        title,
        message,
        suiteNumber,
      }),
    });

    const data = await res.json();
    return data;
  } catch (err: any) {
    console.error('Falha ao acionar envio de WhatsApp:', err);
    return {
      success: false,
      configured: false,
      error: err.message || 'Erro de rede ao enviar notificação de WhatsApp.',
    };
  }
}
